/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"8\"><path fill=\"#F66\" d=\"M7.465 6h3.07A4 4 0 1113 7.874V8H4a4 4 0 113.465-2zM4 6a2 2 0 100-4 2 2 0 000 4zm10 0a2 2 0 100-4 2 2 0 000 4z\"/></svg>\n";
//# sourceMappingURL=voicemail-red.svg.js.map